import React, { useEffect } from "react"
import { navigate } from "gatsby"
import Layout from "../components/layout"
import { Header1, Paragraph } from "../components/headings"

// Press releases now live under News → Press Releases.
// This page redirects the old /press-release URL to its new home.
const DEST = "/articles/press-releases"

const PressRelease = () => {
  useEffect(() => {
    navigate(DEST, { replace: true })
  }, [])
  return (
    <Layout>
      <div style={{ padding: "4rem 2rem", textAlign: "center" }}>
        <Header1>Redirecting…</Header1>
        <Paragraph>
          If you are not redirected automatically,{" "}
          <a href={DEST}>view the latest press releases</a>.
        </Paragraph>
      </div>
    </Layout>
  )
}

export default PressRelease
